import { atom } from 'recoil';
import { IQuestData, IQuestStep } from '../../../game-server/src/modules/quest/Quest.interface';

export const questAtom = atom({
	key: 'questAtom',
	default: { quest: 0, step: 0 } as { quest: IQuestData['id']; step: IQuestStep['stepID'] },
});
